import {ReleaseNoteCard} from "./release-note-card";
import {components} from "@/openapi/generated";
import {cn} from "@/lib/utils";
import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardContent, CardHeader } from "@/components/ui/card";

type ReleaseNoteListItem = components["schemas"]["ReleaseNoteListDto"];

interface ReleaseNoteGridProps {
    releaseNotes: ReleaseNoteListItem[];
    loading?: boolean;
    className?: string;
}

export function ReleaseNoteSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: count }).map((_, i) => (
        <Card key={i} className="h-full">
          <CardHeader className="space-y-3 pb-4">
            <div className="flex justify-between items-start">
              <Skeleton className="h-5 w-24" /> {/* Category badge */}
              <Skeleton className="h-4 w-16" /> {/* Date */}
            </div>
            <Skeleton className="h-6 w-full" /> {/* Title */}
            <Skeleton className="h-6 w-3/4" /> {/* Title continuation */}
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Skeleton className="h-4 w-full" /> {/* Summary line 1 */}
              <Skeleton className="h-4 w-full" /> {/* Summary line 2 */}
              <Skeleton className="h-4 w-2/3" /> {/* Summary line 3 */}
            </div>
            <div className="flex justify-between items-center pt-2 border-t">
              <Skeleton className="h-4 w-20" /> {/* Importance */}
              <Skeleton className="h-4 w-16" /> {/* PR info */}
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}

export function ReleaseNoteGrid({
                                    releaseNotes,
                                    loading = false,
                                    className,
                                }: ReleaseNoteGridProps) {
    if (loading) {
        return <ReleaseNoteSkeleton count={6}/>;
    }

    return (
        <div className={cn(
            "grid gap-6 md:grid-cols-2 lg:grid-cols-3",
            className
        )}>
            {releaseNotes.map((releaseNote) => (
                <ReleaseNoteCard
                    key={releaseNote.slug}
                    releaseNote={releaseNote}
                />
            ))}
        </div>
    );
}